export * from './myanmar-2d.component';